function initCtrContainsSwiper(section) {
  if (typeof Swiper === 'undefined') return;

  var carousel = section.querySelector('[data-ref="cardsSwiper"]');
  var carouselWrap = section.querySelector('.ctr-contains__carousel-wrap');
  if (!carousel || !carouselWrap || carousel.swiper) return;

  new Swiper(carousel, {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    speed: 600,
    navigation: {
      nextEl: carouselWrap.querySelector('.swiper-button-next'),
      prevEl: carouselWrap.querySelector('.swiper-button-prev'),
      addIcons: false,
    },
    breakpoints: {
      990: {
        slidesPerView: 4,
        spaceBetween: 24,
        allowTouchMove: false,
        loop: false,
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ctr-contains[data-section-id]').forEach(initCtrContainsSwiper);
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ctr-contains[data-section-id]');
    if (section) initCtrContainsSwiper(section);
  });
}
